module.exports = __webpack_public_path__ + "b29d59f0a4892becb83a8ad6c2e4790c.svg";